import { render, staticRenderFns } from "./base-edit.vue?vue&type=template&id=227e0c90"
import script from "./base-edit.vue?vue&type=script&lang=js"
export * from "./base-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports